import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useState } from "react";
import { mode } from "@/lib/helpers/mode";
const ItemCardMediaAspectRatioContext = createContext({});
export function ItemCardMediaAspectRatioProvider(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [aspectRatios, setAspectRatios] = useState(t1);
  let t2;
  bb0: {
    let t3;
    if ($[1] !== aspectRatios) {
      const aspectRatioList = Object.values(aspectRatios);
      if (aspectRatioList.length === 0) {
        t2 = 1;
        break bb0;
      }
      t3 = mode(aspectRatioList);
      $[1] = aspectRatios;
      $[2] = t3;
      $[3] = t2;
    } else {
      t3 = $[2];
      t2 = $[3];
    }
    t2 = t3;
  }
  const defaultAspectRatio = t2;
  let t3;
  if ($[4] !== aspectRatios || $[5] !== defaultAspectRatio) {
    t3 = function createState(id) {
      return {
        aspectRatio: (id ? aspectRatios[id] : null) || defaultAspectRatio || 1,
        setAspectRatio: (width, height) => {
          if (!id) {
            return;
          }
          const newAspectRatio = width / height;
          if (!newAspectRatio) {
            return;
          }
          setAspectRatios(existingAspectRatios => ({
            ...existingAspectRatios,
            [id]: newAspectRatio
          }));
        }
      };
    };
    $[4] = aspectRatios;
    $[5] = defaultAspectRatio;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const createState = t3;
  let t4;
  if ($[7] !== createState) {
    t4 = {
      createState
    };
    $[7] = createState;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== t4) {
    t5 = <ItemCardMediaAspectRatioContext.Provider value={t4}>{children}</ItemCardMediaAspectRatioContext.Provider>;
    $[9] = children;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export function useAspectRatio(id) {
  const $ = _c(4);
  const {
    createState
  } = useContext(ItemCardMediaAspectRatioContext);
  if (!createState) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        aspectRatio: 1,
        setAspectRatio: _temp
      };
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== createState || $[2] !== id) {
    t0 = createState(id);
    $[1] = createState;
    $[2] = id;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
function _temp() {
  return false;
}